import { makeStyles, withStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import { checkIsOnlyMainItem } from '../../../../../../components/menu/products/extras/ui/AddExtrasFormDialog';
import { ProductType } from '../../../../../../components/menu/products/ItemsContainer';
import { TriggersTooltips } from '../../../TriggersTooltip';
import { TooltipContentMarkup } from '../../../../../../components/menu/products/extras/ui/TooltipContentMarkup';
export interface IAdvancedChecklistItem {
    itemData: any;
    mainLabelKey: string;
    subLabelKey?: string;
    onClick: (id: string) => void;
    // Optional selected props
    selected?: boolean;
    hasMainItemTag?: boolean;
    disableItemTypeSelection?: ProductType;
    itemToolbar?: (id: string, getSelected: () => any[]) => JSX.Element;
    getSelected?: () => any[];
    idKey: string;
}

const useStyles = makeStyles({
    AdvancedChecklistItemDisabled: {
        '&>div:first-child': {
            '& >div:nth-child(2)': {
                '& >p': {
                    color: '#9E9E9E !important',
                },
            },
        },
    },
    AdvancedChecklistItem: {
        display: 'grid',
        gridTemplateColumns: '65% 35%',
        alignItems: 'center',
        height: '100%',
        margin: '2px 0',
        '&>div:first-child': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            '& >div:nth-child(2)': {
                marginLeft: '1rem',
                '@media only screen and (max-width: 600px)': {
                    maxWidth: '13rem',
                },
                '@media only screen and (max-width: 500px)': {
                    maxWidth: '10rem',
                },
                '& >p:first-child': {
                    fontSize: '1rem',
                    color: '#616161',
                    margin: '0',
                    width: '100%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                },
                '& >p:nth-child(2)': {
                    fontSize: '0.875rem',
                    color: '#757575',
                    margin: '0',
                    width: '100%',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                },
            },
        },
        '&:hover': {
            backgroundColor: '#F3F4F9 !important',
            cursor: 'pointer',
            borderRadius: '8px',
        },
        '& >div:nth-child(2)': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
        },
    },
    AdvancedChecklistItemSelected: {
        '&>div:first-child': {
            '& >div:nth-child(2)': {
                '& >p:first-child': {
                    color: '#212121',
                },
            },
        },
    },
    mainItemTag: {
        border: '1px solid #C1CAE1',
        borderRadius: '0.875rem',
        textAlign: 'center',
        padding: '5px 0.625rem',
        '&>p': {
            color: '#AAB6D3',
            fontSize: '0.8125rem',
            margin: '0',
        },
    },
    itemToolbar: {
        display: 'flex',
        flexDirection: 'row-reverse',
        padding: '0 1rem',
        alignItems: 'center',
    },
});

const CustomCheckbox = withStyles((theme) => ({
    root: {
        color: '#F3F4F9',
        '& .MuiIconButton-label': {
            position: 'relative',
            zIndex: 0,
        },
        '&:not($checked) .MuiIconButton-label:after': {
            content: '""',
            left: 2,
            top: 2,
            height: 18,
            width: 18,
            position: 'absolute',
            backgroundColor: '#F3F4F9',
            zIndex: -1,
            border: '1px solid',
            borderRadius: 4,
        },
        '& svg': {
            width: 18,
            height: 18,
        },
    },
    checked: {},
    disabled: {
        color: '#F3F4F9 !important',
    },
}))(Checkbox);

function AdvancedChecklistItem(props: IAdvancedChecklistItem) {
    const classes = useStyles();
    const [disabled, setDisabled] = useState<boolean>(false);
    useEffect(() => {
        const mainItem = checkIsOnlyMainItem(props.itemData);
        if (
            (props.disableItemTypeSelection === ProductType.MainItem && mainItem) ||
            (props.disableItemTypeSelection === ProductType.ExtraItem && !mainItem)
        ) {
            setDisabled(true);
        }
        // eslint-disable-next-line
    }, [props.disableItemTypeSelection]);

    const getClassNames = () => {
        return `${disabled ? classes.AdvancedChecklistItemDisabled : ''} ${classes.AdvancedChecklistItem} ${
            (props.itemData.selected || props.selected) && !disabled ? classes.AdvancedChecklistItemSelected : ''
        } `;
    };

    return (
        <TriggersTooltips title={<TooltipContentMarkup />} disabled={disabled}>
            <div
                className={getClassNames()}
                onClick={() => {
                    if (!disabled) {
                        props.onClick(props.itemData[props.idKey]);
                    }
                }}
            >
                <div>
                    <div>
                        <CustomCheckbox
                            checked={props.itemData.selected || props.selected}
                            color={'primary'}
                            disabled={disabled}
                        />
                    </div>
                    <div>
                        <p>{props.itemData[props.mainLabelKey]}</p>
                        {props.subLabelKey && <p>{props.itemData[props.subLabelKey]}</p>}
                    </div>
                </div>
                <div>
                    {props.itemToolbar && props.itemData[props.idKey] && props.getSelected && (
                        <span className={classes.itemToolbar}>
                            {props.itemToolbar(props.itemData[props.idKey], props.getSelected)}
                        </span>
                    )}
                </div>
            </div>
        </TriggersTooltips>
    );
}

export default AdvancedChecklistItem;
